<!--
component: BrowseBuildingShobun
author: Ken Nakamura
description: 建築計画概要書（処分の概要書）
-->
<template>
  <section class="A4">
    <br>
    <p class="gaiyo-youshiki">第三十七号様式（第六条の三、第十一条の四関係）（Ａ４）</p>
    <p class="gaiyo-section-header">建築基準法令による処分等の概要書</p>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【1.建築確認】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title left-08">【ｲ.確認済証交付者】</div>
      <div class="gaiyo-items">
        <div class="shobun-element left-55">{{gaiyo.shinsei.dlvrer}}</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="shobun-minor-title left-08">【ﾛ.確認済証番号】</div>
      <div class="gaiyo-items">
        <div class="shobun-element left-55 shobun-no">{{gaiyo.shinsei.kknN_NO}}</div>
        <!--<div class="gaiyo-element left-55">{{gaiyo.orgKknnNo}}</div>-->
        <div class="shobun-element left-125">【ﾊ.交付年月日】</div>
        <div class="shobun-element left-155">{{dateTextToWareki(gaiyo.shinsei.kknN_DAY)}}</div>
        <!--<div class="gaiyo-element left-155">{{dateTextToWareki(gaiyo.orgKknnDay)}}</div>-->
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">（計画変更の確認）</div>
    </div>
    <div class="gaiyo-row"
      v-for="(h, index) in gaiyo.henko"
      :key="`henko-${index}`">
      <div class="shobun-element left-02">({{h.seQ_NO}})</div>
      <div class="shobun-element left-08">【ｲ.確認済証交付者】</div>
      <div class="shobun-element left-55">{{h.dlvrer}}</div>
      <br>
      <div class="shobun-element left-08">【ﾛ.確認済証番号】</div>
      <div class="shobun-element left-55 shobun-no">{{h.kknN_NO}}</div>
      <div class="shobun-element left-125">【ﾊ.交付年月日】</div>
      <div class="shobun-element left-155">{{dateTextToWareki(h.kknN_DAY)}}</div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">（構造計算適合性判定）</div>
    </div>
    <div class="gaiyo-row"
      v-for="(k, index) in gaiyo.kozoTekigo"
      :key="`tekigo-${index}`">
      <div class="shobun-element left-08">【ｲ.判定結果通知書交付者】</div>
      <div class="shobun-element left-55">{{k.dlvrer}}</div>
      <br>
      <div class="shobun-element left-08">【ﾛ.判定結果通知者交付番号】</div>
      <div class="shobun-element left-55 shobun-no">{{k.kknN_NO}}</div>
      <div class="shobun-element left-125">【ﾊ.交付年月日】</div>
      <div class="shobun-element left-155">{{dateTextToWareki(k.kknN_DAY)}}</div>
      <br>
    </div>
    <browse-building-chukan :chukan="gaiyo.chukan"
      :startIndex="chukanStart" :endIndex="chukanEnd" />
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【3.完了検査】</div>
    </div>
    <div class="gaiyo-row">
      <div class="shobun-minor-title left-08">【ｲ.検査日】</div>
      <div class="gaiyo-items">
        <div class="shobun-element left-55">{{dateTextToWareki(gaiyo.kanryo.kensA_DAY)}}</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="shobun-minor-title left-08">【ﾛ.検査済証交付者】</div>
      <div class="gaiyo-items">
        <div class="shobun-element left-55">{{gaiyo.kanryo.dlvrer}}</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="shobun-minor-title left-08">【ﾊ.検査済証番号】</div>
      <div class="gaiyo-items">
        <div class="shobun-element left-55 shobun-no">{{gaiyo.kanryo.kknN_NO}}</div>
        <div class="shobun-element left-125">【ﾆ.交付年月日】</div>
        <div class="shobun-element left-155">{{dateTextToWareki(gaiyo.kanryo.kknN_DAY)}}</div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【4.その他の処分】</div>
    </div>
    <div class="gaiyo-row"
      v-for="(e, index) in gaiyo.etcShobun"
      :key="`etc-${index}`">
      <div class="shobun-element left-08">{{dateTextToWareki(e.tsuchI_DAY)}}</div>
      <div class="shobun-element left-30">{{e.dlvrer}}</div>
      <div class="shobun-element left-65">{{e.jokO_NO}}</div>
      <div class="shobun-element left-100">{{e.kofU_NO}}</div>
      <br>
    </div>
    <br><hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【5.定期報告等】</div>
    </div>
    <div class="gaiyo-row"
      v-for="(t, index) in gaiyo.teiki"
      :key="`teiki-${index}`">
      <div class="shobun-element left-02">({{t.seQ_NO}})</div>
      <div class="shobun-element left-07">【報告年月日】</div>
      <div class="shobun-element left-55">{{dateTextToWareki(t.teikI_DAY)}}</div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【6.備考】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="shobun-element left-07">{{gaiyo.shinsei.biko}}</div>
      </div>
      <br>
    </div>
  <hr>
  </section>
</template>

<script>
import BrowseBuildingChukan from '../components/building/BrowseBuildingChukan.vue'

export default {
  components: {
    BrowseBuildingChukan,
  },
  props: {
    firstPart: {
      type: Number,
      default: () => 1
    },
    lastPart: {
      type: Number,
      default: () => 6
    },
    henkoStart: {
      type: Number,
      default: () => 0
    },
    henkoEnd: {
      type: Number,
      default: () => 5
    },
    chukanStart: {
      type: Number,
      default: () => 0
    },
    chukanEnd: {
      type: Number,
      default: () => 5
    },
    gaiyo: {
      type: Object,
      default: null
    },
  },
  computed: {
  },
  methods: {
    dateTextToWareki(date) {
      if (date) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        date = new Date(year, month - 1, day);
        return new Intl.DateTimeFormat(
          'ja-JP-u-ca-japanese',
          {
            era: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }
        ).format(date);
      }
      else {
        return '';
      }
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>